import * as React from 'react'
import Main from '../Components/Main'

interface Props { }

interface State {
}

export class Student extends React.Component<Props, State> {

    public render () {
        return (
            <Main>
                <div> This is the stiudent page</div>
            </Main>
        )
    }
}

export default Student